import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import FlowButton from './FlowButton';

function StartExerciseButton ({onClick}) {
    
    return <FlowButton className='baseElementsconfirmButton' onClick={onClick} name={"Iniziamo!"}></FlowButton>
}

export default StartExerciseButton;